import React from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import { LuRefreshCw } from "react-icons/lu";
import { useAdminData } from "../services/adminDataStore";

export function PageSpinner() {
	return (
		<Box
			display="flex"
			alignItems="center"
			justifyContent="center"
			minHeight="calc(100vh - 48px)"
			flexDirection="column"
			gap={1.5}
		>
			<CircularProgress size={36} thickness={4} sx={{ color: "#A855F7" }} />
			<Typography fontSize={13} color="#8B93A1">Loading live data…</Typography>
		</Box>
	);
}

export default function AdminPageHeader({ title, subtitle, actions }) {
	const { refresh, loading, loaded } = useAdminData();

	return (
		<Box mb={3} display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={1.5}>
			<Box>
				<Typography variant="h5" fontWeight={700} color="#12131A">{title}</Typography>
				{subtitle && (
					<Typography sx={{ color: "#8B93A1", fontSize: 13, mt: 0.5 }}>
						{subtitle}
					</Typography>
				)}
			</Box>
			<Box display="flex" gap={1} flexWrap="wrap" alignItems="center">
				{actions}
				<Button
					size="small"
					onClick={refresh}
					disabled={loading}
					startIcon={
						loading
							? <CircularProgress size={14} sx={{ color: "inherit" }} />
							: <LuRefreshCw size={15} />
					}
					sx={{
						px: 2,
						py: 0.9,
						borderRadius: "12px",
						textTransform: "none",
						fontWeight: 600,
						color: "#374151",
						background: "#FFFFFF",
						border: "1px solid #E5E7EB",
						boxShadow: "0 1px 2px rgba(17,19,26,0.04)",
						"&:hover": { background: "#F3F4F6", borderColor: "#D1D5DB" },
						"&.Mui-disabled": { color: "#9CA3AF", background: "#F9FAFB" },
					}}
				>
					{loading && loaded ? "Reloading…" : "Reload"}
				</Button>
			</Box>
		</Box>
	);
}